import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../features/Api/apiSlice";
import authSliceReducer from "../features/Auth/authSlice";
// admin
import videosSliceReducer from "../features/Admin/Videos/videosSlice";
import assignmentSliceReducer from "../features/Admin/Assignments/assignmentsSlice";
import quizzesSliceReducer from "../features/Admin/Quizzes/quizzesSlice";
import assignmentsMarkSliceReducer from "../features/Admin/AssignmentsMark/assignmentsMarkSlice";
// Student
import coursePlayerSliceReducer from "../features/Student/CoursePlayer/coursePlayerSlice";
import quizSliceReducer from "../features/Student/Quiz/quizSlice";
import leaderboardSliceReducer from "../features/Student/Leaderboard/leaderboardSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authSliceReducer,
    // Admin reducer
    assignments: assignmentSliceReducer,
    assignmentsMark: assignmentsMarkSliceReducer,
    quizzes: quizzesSliceReducer,
    videos: videosSliceReducer,
    // Student reducer
    coursePlayer: coursePlayerSliceReducer,
    quiz: quizSliceReducer,
    leaderboard: leaderboardSliceReducer,
  },
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddlewares) =>
    getDefaultMiddlewares().concat(apiSlice.middleware),
});
